import { PostsRoute } from '@/features/posts/navigation/postsRoute';
import { HappeningParticipantsScreen } from '@/features/posts/screens/HappeningParticipantsScreen';
import { PostDetailScreen } from '@/features/posts/screens/PostDetailScreen';
import { PostSearchScreen } from '@/features/posts/screens/PostSearchScreen';
import { NavigationBar } from '@/navigation/components/navbar/NavigationBar';
import { AppStack } from '@/navigation/stacks/appStack';
import { NavBarType } from '@/navigation/types/navbar';

export const usePostsRouting = () => ({
  postsScreens: [
    <AppStack.Screen
      key={PostsRoute.PostDetail}
      name={PostsRoute.PostDetail}
      component={PostDetailScreen}
      options={{ headerShown: true }}
    />,
    <AppStack.Screen
      key={PostsRoute.PostSearch}
      name={PostsRoute.PostSearch}
      component={PostSearchScreen}
      options={{ headerShown: false }}
    />,
    <AppStack.Screen
      key={PostsRoute.HappeningParticipants}
      name={PostsRoute.HappeningParticipants}
      component={HappeningParticipantsScreen}
      options={{
        header: () => <NavigationBar type={NavBarType.MODAL_WITH_CLOSE} />,
        headerShown: true,
        presentation: 'containedModal',
        animation: 'fade'
      }}
    />
  ]
});
